import Box from '@mui/material/Box';
import { FormActions } from '@openx/components-core/lib/FormActions/FormActions.tsx';
import { useFormState } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { ApplyDiscountToSection } from './sections/ApplyDiscountToSection.tsx';
import { DiscountDetailsSection } from './sections/DiscountDetailsSection.tsx';
import type { CuratedDealBuyerDiscountsFormData } from './types.ts';

type CuratedDealBuyerDiscountsFormSectionsProps = {
  isEdit: boolean;
  seatIds?: Record<string, true> | null;
};

export const CuratedDealBuyerDiscountsFormSections = ({
  isEdit,
  seatIds,
}: CuratedDealBuyerDiscountsFormSectionsProps) => {
  const { isDirty, isSubmitting } = useFormState<CuratedDealBuyerDiscountsFormData>();
  const navigate = useNavigate();

  return (
    <>
      <Box>
        <DiscountDetailsSection />
        <ApplyDiscountToSection isEdit={isEdit} seatIds={seatIds} />
      </Box>

      <FormActions
        disabled={isSubmitting || (isEdit && !isDirty)}
        isSubmitting={isSubmitting}
        onCancel={() => navigate('/discounts')}
      />
    </>
  );
};
